import * as yup from "yup";

export const updateLicenseCertificateValidator = yup.object({
  hostname: yup.string().required("Field is required"),
  expiration_date: yup.string().required("Field is required"),
});
